import request from '@/utils/request'

// 查询走进财金化学详细
export function getEnter(id) {
  return request({
    url: '/basic/enter/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/enter/enter.js